import React from 'react';

const EmailPreview = () => {
  return (
    <div style={{
      margin: 0, 
      padding: '20px', 
      fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
      minHeight: '100vh'
    }}>
      
      <div style={{
        maxWidth: '600px', 
        margin: '0 auto', 
        background: '#ffffff', 
        borderRadius: '24px', 
        overflow: 'hidden', 
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        
        {/* Professional Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #8b5cf6 100%)',
          padding: '40px 32px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          
          {/* Subtle Pattern Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            opacity: 0.3
          }} />
          
          {/* Puffin Group Logo */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.95)',
            width: '100px',
            height: '100px',
            borderRadius: '50%',
            margin: '0 auto 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
            border: '3px solid rgba(255, 255, 255, 0.2)',
            position: 'relative',
            zIndex: 2
          }}>
            {/* Puffin Group Company Logo */}
            <img 
              src="/logo.png" 
              alt="Puffin Group Ltd" 
              style={{
                width: '60px',
                height: '60px',
                objectFit: 'contain'
              }}
              onError={(e) => {
                // Fallback to text if logo not found
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{
              display: 'none',
              color: '#1f2937',
              fontSize: '24px',
              fontWeight: '700'
            }}>
              PG
            </div>
          </div>
          
          <h1 style={{
            color: 'white',
            margin: '0 0 8px',
            fontSize: '32px',
            fontWeight: '700',
            letterSpacing: '-0.5px',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            zIndex: 2
          }}>
            PUFFIN GROUP LTD
          </h1>
          
          <p style={{
            color: 'rgba(255, 255, 255, 0.9)',
            margin: 0,
            fontSize: '16px',
            fontWeight: '500',
            position: 'relative',
            zIndex: 2
          }}>
            With Puffin, Best Quality is Assured
          </p>
        </div>

        {/* Professional Content Section */}
        <div style={{padding: '40px 32px'}}>
          
          {/* Notification Header */}
          <div style={{textAlign: 'center', marginBottom: '32px'}}>
            <div style={{
              background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
              width: '64px',
              height: '64px',
              borderRadius: '16px',
              margin: '0 auto 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 10px 25px rgba(59, 130, 246, 0.3)'
            }}>
              <svg width="28" height="28" fill="white" viewBox="0 0 24 24">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
              </svg>
            </div>
            
            <h2 style={{
              color: '#1f2937',
              margin: '0 0 8px',
              fontSize: '24px',
              fontWeight: '700',
              letterSpacing: '-0.3px'
            }}>
              Purchase Request Approval Required
            </h2>
            
            <p style={{
              color: '#6b7280',
              margin: 0,
              fontSize: '16px',
              fontWeight: '500'
            }}>
              A new high-priority request awaits your review
            </p>
          </div>

          {/* Professional Request Card */}
          <div style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            borderRadius: '16px',
            padding: '24px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            marginBottom: '32px'
          }}>
            
            {/* Card Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
              paddingBottom: '16px',
              borderBottom: '1px solid #e2e8f0'
            }}>
              <h3 style={{
                color: '#1f2937',
                margin: 0,
                fontSize: '18px',
                fontWeight: '600'
              }}>
                Request Details
              </h3>
              <span style={{
                background: 'linear-gradient(135deg, #10b981, #059669)',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                Transfer Payment
              </span>
            </div>
            
            {/* Professional Details Grid */}
            <div style={{display: 'grid', gap: '16px'}}>
              
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{color: '#6b7280', fontWeight: '500', fontSize: '14px'}}>
                  Request ID
                </span>
                <span style={{
                  color: '#1f2937',
                  fontWeight: '700',
                  fontSize: '14px',
                  fontFamily: 'Monaco, Consolas, monospace',
                  background: '#f3f4f6',
                  padding: '4px 8px',
                  borderRadius: '6px'
                }}>
                  PR-2024-001
                </span>
              </div>
              
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{color: '#6b7280', fontWeight: '500', fontSize: '14px'}}>
                  Vendor
                </span>
                <span style={{color: '#1f2937', fontWeight: '600', fontSize: '14px'}}>
                  Tech Solutions Ltd
                </span>
              </div>
              
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{color: '#6b7280', fontWeight: '500', fontSize: '14px'}}>
                  Amount
                </span>
                <span style={{
                  color: '#dc2626',
                  fontWeight: '800',
                  fontSize: '18px',
                  letterSpacing: '-0.3px'
                }}>
                  ₦2,500,000.00
                </span>
              </div>
              
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{color: '#6b7280', fontWeight: '500', fontSize: '14px'}}>
                  Requested by
                </span>
                <span style={{color: '#1f2937', fontWeight: '600', fontSize: '14px'}}>
                  John Doe
                </span>
              </div>
              
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <span style={{color: '#6b7280', fontWeight: '500', fontSize: '14px'}}>
                  Bank Details
                </span>
                <span style={{
                  color: '#1f2937',
                  fontWeight: '500',
                  fontSize: '13px',
                  fontFamily: 'Monaco, Consolas, monospace'
                }}>
                  Access Bank - 1234567890
                </span>
              </div>
            </div>
          </div>

          {/* Professional CTA */}
          <div style={{textAlign: 'center', marginBottom: '32px'}}>
            <a href="#" style={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
              color: 'white',
              padding: '16px 32px',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '600',
              fontSize: '16px',
              display: 'inline-block',
              boxShadow: '0 10px 25px rgba(59, 130, 246, 0.3)',
              transition: 'all 0.2s ease',
              border: 'none',
              cursor: 'pointer'
            }}>
              Review & Approve Request
            </a>
          </div>

          {/* Professional Notice */}
          <div style={{
            background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
            borderRadius: '12px',
            padding: '16px 20px',
            border: '1px solid #f59e0b',
            textAlign: 'center'
          }}>
            <p style={{
              color: '#92400e',
              margin: 0,
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '1.5'
            }}>
              <strong>Action Required:</strong> This request requires immediate attention due to its high value and priority status.
            </p>
          </div>
        </div>

        {/* Professional Footer */}
        <div style={{
          background: '#f8fafc',
          padding: '24px 32px',
          textAlign: 'center',
          borderTop: '1px solid #e2e8f0'
        }}>
          <div style={{marginBottom: '12px'}}>
            <div style={{
              width: '40px',
              height: '2px',
              background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
              margin: '0 auto',
              borderRadius: '1px'
            }} />
          </div>
          
          <p style={{
            color: '#6b7280',
            margin: '0 0 8px',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            © 2026 Puffin Group Ltd. All rights reserved.
          </p>
          
          <p style={{
            color: '#9ca3af',
            margin: 0,
            fontSize: '12px',
            fontWeight: '400'
          }}>
            This is an automated notification from the ERP system.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailPreview;
